import { InjectionToken, Type } from '@angular/core';

export type UiCustomComponents = UiCustomComponent<any>[];

export interface UiCustomComponent<T> {
  key: string;
  type: 'form' | 'externalObjectCard' | 'linkedObjectCard';
  component: Type<T>;
  data?: (...args: any[]) => { [key in keyof T]?: T[key] };
}

export const UI_MODULE_CUSTOM_COMPONENTS =
  new InjectionToken<UiCustomComponents>('UiCustomComponents');
